<template>
<span v-tooltip="{
  trigger: 'hover',
  offset: 5,
  placement: 'top',
  content: description }">
  <svgicon
    :name="imgName"
    height="20"
    width="20"
    :original="true">
  </svgicon>
</span>
</template>

<script>
export default {
  name: 'AnalyticEventTypeIcon',
  props: {
    analytic: {
      type: Object,
      required: true,
    },
  },
  computed: {
    imgName() {
      if (Object.prototype.hasOwnProperty.call(this.$typeDefs.events, this.analytic.inputType)) {
        return this.$typeDefs.events[this.analytic.inputType].icon;
      }
      return 'circle';
    },
    description() {
      if (Object.prototype.hasOwnProperty.call(this.$typeDefs.events, this.analytic.inputType)) {
        const def = this.$typeDefs.events[this.analytic.inputType];
        return `${def.type}: ${def.description}`;
      }
      return '';
    },
  },
};
</script>
